import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SnackbarInformationIcon = forwardRef<SVGSVGElement, IconProps>(function SnackbarInformationIcon(
  { color = '#2A75E4', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.5 12.2998C22.5 18.0988 17.799 22.7998 12 22.7998C6.20101 22.7998 1.5 18.0988 1.5 12.2998C1.5 6.50082 6.20101 1.7998 12 1.7998C17.799 1.7998 22.5 6.50082 22.5 12.2998Z"
        fill="url(#paint0_radial_389_22880)"
        stroke="#3A65FD"
      />
      <path
        d="M11.6999 8.89305C12.2719 8.89305 12.7356 8.42938 12.7356 7.85741C12.7356 7.28545 12.2719 6.82178 11.6999 6.82178C11.128 6.82178 10.6643 7.28545 10.6643 7.85741C10.6643 8.42938 11.128 8.89305 11.6999 8.89305Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M9.62866 12C9.62866 11.428 10.0923 10.9643 10.6643 10.9643H11.6999C12.2719 10.9643 12.7356 11.428 12.7356 12V15.1069C13.3075 15.1069 13.7712 15.5705 13.7712 16.1425C13.7712 16.7145 13.3075 17.1781 12.7356 17.1781H11.6999C11.128 17.1781 10.6643 16.7145 10.6643 16.1425V13.0356C10.0923 13.0356 9.62866 12.5719 9.62866 12Z"
        fill={color || 'currentColor'}
      />
      <defs>
        <radialGradient
          id="paint0_radial_389_22880"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23 12.2998) rotate(179.974) scale(39.875 205.333)"
        >
          <stop stopColor="#2A75E4" stopOpacity="0.31" />
          <stop offset="0.489583" stopColor="#2A75E4" stopOpacity="0.3" />
        </radialGradient>
      </defs>
    </svg>
  );
});
